"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErroPedidoHorariosIguais = exports.FormatoDeHorasInvalido = exports.EntradaDeDadosInvalida = exports.PedidoDeHorasExtrasParaPeriodoPassado = exports.PedidoIntercedeJornadaDoDia = void 0;
class PedidoIntercedeJornadaDoDia extends Error {
    constructor() {
        super('o horário de solicitação de hora extra está dentro da jornada esperada. Por favor, selecione outro horário.');
    }
}
exports.PedidoIntercedeJornadaDoDia = PedidoIntercedeJornadaDoDia;
class PedidoDeHorasExtrasParaPeriodoPassado extends Error {
    constructor() {
        super('A data do pedido é anterior a data de hoje');
    }
}
exports.PedidoDeHorasExtrasParaPeriodoPassado = PedidoDeHorasExtrasParaPeriodoPassado;
class EntradaDeDadosInvalida extends Error {
    constructor() {
        super('Entrada de dados inválida');
    }
}
exports.EntradaDeDadosInvalida = EntradaDeDadosInvalida;
class FormatoDeHorasInvalido extends Error {
    constructor() {
        super('Formato de horas inválido');
    }
}
exports.FormatoDeHorasInvalido = FormatoDeHorasInvalido;
class ErroPedidoHorariosIguais extends Error {
    constructor() {
        super('Os horários de início e término não podem ser iguais');
    }
}
exports.ErroPedidoHorariosIguais = ErroPedidoHorariosIguais;
//# sourceMappingURL=excecoes.js.map